module.exports = __webpack_public_path__ + "img/747-15a0d2.png";